<h2 mat-dialog-title>Отказ и возврат денег · №{{ data.orderId }}</h2>
<mat-progress-bar *ngIf="loading || saving" mode="indeterminate"></mat-progress-bar>
<mat-dialog-content>
  <ng-container *ngIf="preview as p">
    <div class="summary">
      <div><span>Оплачено</span><strong>{{ p.paid_total | number:'1.2-2' }} грн</strong></div>
      <div><span>Уже возвращено</span><strong>{{ p.refunded_total | number:'1.2-2' }} грн</strong></div>
      <div class="due"><span>{{ p.needs_confirmation ? 'К возврату после отказа' : 'Осталось вернуть' }}</span>
        <strong>{{ p.refund_due_total | number:'1.2-2' }} грн</strong></div>
      <div *ngIf="p.wallet_credited_total"><span>Зачислено на баланс</span><strong>{{ p.wallet_credited_total | number:'1.2-2' }} грн</strong></div>
    </div>
    <p class="warning" *ngIf="p.blocked_reason" role="alert">{{ p.blocked_reason }}</p>
    <ng-container *ngIf="!p.blocked_reason">
      <p *ngIf="p.needs_confirmation">Полный отказ от заказа до выдачи клиенту. Резервы будут освобождены;
        для отобранного товара склад получит задачу возврата. Закупки и возвраты поставщику проверяются отдельно.</p>
      <p class="success" *ngIf="!p.needs_confirmation">Отказ оформлен. Выдача денег учитывается отдельно.</p>
      <section *ngFor="let invoice of p.invoices" class="invoice">
        <div class="invoice-title"><b>Счёт №{{ invoice.id }}</b><span>{{ invoice.cancel_total | number:'1.2-2' }} грн к отмене</span></div>
        <div *ngFor="let item of invoice.items" class="item">
          <span>{{ item.description }} <small>{{ item.article }}</small></span>
          <span>{{ item.quantity | number:'1.0-2' }} × {{ item.price | number:'1.2-2' }}</span>
        </div>
        <p class="pending" *ngIf="invoice.refund_pending_total > 0">В обработке: {{ invoice.refund_pending_total | number:'1.2-2' }} грн.
          Продолжите существующий возврат в истории.</p>
      </section>
      <mat-form-field appearance="outline" *ngIf="p.needs_confirmation">
        <mat-label>Причина отказа</mat-label>
        <textarea matInput [formControl]="reason" rows="2" maxlength="500" [readonly]="saving || uncertain"></textarea>
        <mat-error>Укажите причину отказа</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngIf="refundableInvoices.length > 1">
        <mat-label>Счёт для возврата</mat-label>
        <mat-select [(ngModel)]="invoiceId" [disabled]="saving">
          <mat-option *ngFor="let invoice of refundableInvoices" [value]="invoice.id">
            №{{ invoice.id }} · {{ invoice.available_refund_after | number:'1.2-2' }} грн
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-customer-account-return *ngIf="accountInvoiceId" [invoiceId]="accountInvoiceId" [accepted]="!p.needs_confirmation" (managedChange)="customerAccountManaged = $event"></app-customer-account-return>
      <p *ngIf="selectedInvoice && !customerAccountManaged">На следующем экране проверьте текущую кассу и подтвердите выдачу
        {{ selectedInvoice.available_refund_after | number:'1.2-2' }} грн. Закрытая смена исходной оплаты сохранится.</p>
    </ng-container>
  </ng-container>
  <p class="error" *ngIf="error" role="alert">{{ error }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="ref.close(changed)" [disabled]="saving">Закрыть</button>
  <button mat-button type="button" (click)="load()" [disabled]="saving || loading || uncertain">Обновить</button>
  <button mat-stroked-button type="button" *ngIf="preview && !preview.needs_confirmation" (click)="openHistory()">История возвратов</button>
  <button mat-stroked-button type="button" *ngIf="preview?.needs_confirmation" [disabled]="!canConfirm" (click)="confirm(false)">
    {{ uncertain ? 'Проверить отказ' : 'Оформить отказ' }}
  </button>
  <button mat-flat-button color="primary" type="button" *ngIf="preview?.needs_confirmation && invoiceId && !customerAccountManaged"
    [disabled]="!canConfirm" (click)="confirm(true)">Оформить и перейти к возврату</button>
  <button mat-flat-button color="primary" type="button" *ngIf="preview && !preview.needs_confirmation && invoiceId && !customerAccountManaged"
    [disabled]="saving || loading || !!preview.blocked_reason" (click)="openRefund()">Перейти к выдаче денег</button>
</mat-dialog-actions>
